// Resolves /l/{slug} to the league's detail page.
//
// Same shape as TournamentRedirect: the shareable link is a slug an admin
// chooses, and the doc id it points at is an implementation detail nobody
// should have to paste into a group chat. Kept as a redirect rather than
// serving the league at /l/{slug} so there is still exactly one canonical
// URL for a league.
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../firebase';
import { Box, CircularProgress, Typography, Button } from '@mui/material';

export default function LeagueRedirect() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    const resolve = async () => {
      try {
        const snap = await getDocs(query(collection(db, 'leagues'), where('slug', '==', slug)));
        if (snap.empty) {
          setError('League not found.');
          return;
        }
        navigate(`/leagues/${snap.docs[0].id}`, { replace: true });
      } catch (e) {
        setError('Failed to load league.');
      }
    };
    resolve();
  }, [slug, navigate]);

  if (error) return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      minHeight: '100vh', gap: 2, backgroundColor: '#0D1E35', px: 2, textAlign: 'center' }}>
      <Typography variant="h5" sx={{ color: '#C9A84C' }}>{error}</Typography>
      <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.6)' }}>
        The link may be out of date, or the league may have been renamed.
      </Typography>
      <Button variant="outlined" onClick={() => navigate('/leagues')}
        sx={{ color: '#C9A84C', borderColor: 'rgba(201,168,76,0.5)', mt: 1 }}>
        See all leagues
      </Button>
    </Box>
  );

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', backgroundColor: '#0D1E35' }}>
      <CircularProgress sx={{ color: '#C9A84C' }} />
    </Box>
  );
}
